/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { InvoiceCaseResponseJson } from './invoice-case-response-json';
import { InvoiceCaseResult } from '../financials/results/invoice-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { InvoiceDataDto } from '../financials/models/invoice-data-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class InvoiceCaseResponse extends ResponseWithErrorGeneric<InvoiceCaseResponseJson, InvoiceCaseResult> implements IResponseWithErrorGeneric<InvoiceCaseResult> {
  public invoiceData: InvoiceDataDto[];

  //<custom-body>
  constructor(response: HttpResponse<InvoiceCaseResponse>) {
    super(response, InvoiceCaseResult.Error);
    if (this.result !== InvoiceCaseResult.Success) {
      return;
    }

    this.invoiceData = this.body.invoiceData.map(d => new InvoiceDataDto(d));
  }
  //</custom-body>
}
